// extracted by mini-css-extract-plugin
export default {"home-container":"AboutUs_home-container__XE3WE","red":"AboutUs_red__mnzWM","bule":"AboutUs_bule__q+2qy"};